// extracted by mini-css-extract-plugin
export default {"tab":"SaleTabs_tab__ReM0k"};